import React from 'react';
import PropTypes from 'prop-types';
import { contentfulViews, components } from '@glowforge/ui-common';

import './media-card.less';

const { Image: Img } = contentfulViews;
const { Markdown } = components;

/**
 * UI for Card
 * If passed onClick, will be tabbable and clickable.
 */
const MediaCard = ({
  children,
  className,
  image,
  text,
  title,
}) => (
  <div className={`MediaCard ${className}`}>
    <div className='card-image'>
      <Img media={image} />
    </div>
    <div className='card-content'>
      <h3 className='card-title'>{title}</h3>
      <Markdown source={text} />
      {children}
    </div>
  </div>
);

MediaCard.propTypes = {
  image: PropTypes.shape(Img.propTypes),
  title: PropTypes.string,
  text: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
};

MediaCard.defaultProps = {
  image: Img.defaultProps,
  title: null,
  text: null,
  className: '',
  children: null,
};

export default MediaCard;



// WEBPACK FOOTER //
// ./app/components/landing/media-card.jsx